import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { onForgotPassword as onForgotPasswordAction } from "../accountActions";
import LanguageSelector from "../../../common/header/LanguageSelector";
import ForgotPassword from "./forgotPassword";

class ForgotPasswordContainer extends React.Component {
    handleSubmit(values) {
        const { forgotPasswordAction, history } = this.props;
        forgotPasswordAction({
            email: values.email,
            navigation: history,
        });
    }

    render() {
        const { isLoading } = this.props;

        return (
            <div
                className="professional-gradient-bg"
            >
                {/* Decorative background shapes */}
                <div
                    style={{
                        position: "absolute",
                        top: "-100px",
                        right: "-100px",
                        width: "400px",
                        height: "400px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, rgba(9, 129, 196, 0.1) 0%, rgba(74, 144, 226, 0.15) 100%)",
                        filter: "blur(60px)",
                        zIndex: 0,
                        animation: "pulseGlow 8s ease-in-out infinite, driftRight 25s ease-in-out infinite"
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        bottom: "-150px",
                        left: "-150px",
                        width: "500px",
                        height: "500px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, rgba(9, 129, 196, 0.08) 0%, rgba(74, 144, 226, 0.12) 100%)",
                        filter: "blur(80px)",
                        zIndex: 0,
                        animation: "pulseGlow 10s ease-in-out infinite, driftLeft 30s ease-in-out infinite"
                    }}
                />

                <div className="auth-language-corner">
                    <LanguageSelector guest />
                </div>

                <div className="loginMain d-flex position-relative align-items-center" style={{ minHeight: "100vh", height: "100%", width: "100%", zIndex: 1 }}>
                    {/* Left side decorative illustration */}
                    <div className="position-absolute" style={{ left: "5%", bottom: "10%", zIndex: 1 }}>
                        <img
                            src={'/assets/img/signup-left-svg.png'}
                            className="img-fluid"
                            alt="Time Off Ledger"
                            style={{
                                maxHeight: "450px",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                                filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.1))",
                                opacity: 0.9
                            }}
                        />
                    </div>

                    {/* Center form */}
                    <div className="mx-auto" style={{ width: "450px", maxWidth: "90%", zIndex: 2 }}>
                        <ForgotPassword
                            isLoading={isLoading}
                            handleSubmitBtn={(values) => this.handleSubmit(values)}
                        />
                    </div>

                    {/* Right side decorative elements */}
                    <div
                        className="position-absolute"
                        style={{
                            right: "5%",
                            top: "20%",
                            zIndex: 1
                        }}
                    >
                        <div
                            style={{
                                width: "200px",
                                height: "200px",
                                borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
                                background: "linear-gradient(135deg, rgba(9, 129, 196, 0.15) 0%, rgba(74, 144, 226, 0.2) 100%)",
                                filter: "blur(40px)",
                                animation: "float 6s ease-in-out infinite"
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ accountReducer }) => {
    const { isLoading } = accountReducer;
    return { isLoading };
};

const action = {
    forgotPasswordAction: onForgotPasswordAction,
};

export default withRouter(connect(mapStateToProps, action)(ForgotPasswordContainer));

